import { useLazyQuery, useReactiveVar } from '@apollo/client';
import {
  GET_PLAYLISTS,
  GET_PLAYLISTS_SHARED_WITH_ORGANISATION,
} from '../../graphql/queries/playlist/playlist';
import {
  dismissLoadingMessage,
  displayErrorMessage,
} from '../../utils/helpers';
import { organisationLoggedInAs } from '../../utils/reactiveVars';

const useGetPlaylistsLazy = (createdBy, variables) => {
  const organisationRef = useReactiveVar(organisationLoggedInAs)?.id || null;

  const includeOrganisationRefForTypes = ['shared', 'user'];
  const isSharedPlaylists = createdBy === 'shared';
  const query = isSharedPlaylists
    ? GET_PLAYLISTS_SHARED_WITH_ORGANISATION
    : GET_PLAYLISTS;

  const [executeQuery, { data, loading, error }] = useLazyQuery(query, {
    onCompleted: () => dismissLoadingMessage(),
    onError: () => {
      dismissLoadingMessage();
      // suppress error for shared playlists as organisation ref
      // may not be available on page load yet
      if (!isSharedPlaylists) {
        displayErrorMessage('Could not load playlists');
      }
    },
  });

  const loadPlaylists = () => {
    executeQuery({
      variables: {
        ...(!isSharedPlaylists && { createdBy }),
        ...(includeOrganisationRefForTypes.includes(createdBy) && {
          organisation_ref: organisationRef,
        }),
        ...variables,
      },
    });
  };

  return { data, loading, error, loadPlaylists };
};

export default useGetPlaylistsLazy;
